import zxcvbn from 'zxcvbn';

export const validatePassword = (password) => {
  const minLength = 8;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumbers = /\d/.test(password);
  const hasNonalphas = /\W/.test(password);

  if (password.length < minLength) {
    return `Password must be at least ${minLength} characters long.`;
  } else if (!hasUpperCase || !hasLowerCase || !hasNumbers || !hasNonalphas) {
    return 'Password must include uppercase and lowercase letters, numbers, and special characters.';
  }
  return '';
};

export const getPasswordStrength = (password) => {
  const result = zxcvbn(password);
  return result.score; // 0 to 4
};

export const getPasswordStrengthLabel = (score) => {
  return ['Very Weak', 'Weak', 'Fair', 'Strong', 'Very Strong'][score];
};